import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { AlignedTitle } from '../components/styled/Title';
import { ContainerWithFooter, PlanCTA, InfoBox, SubscriptionModals, Loader, CardInfo } from '../components';
import { FlexCol, FlexWrappedRow, MainTitle, ButtonExtraMargin, Spacer } from '../components/styled';
import { backToAppLink } from '../config';
import { redirectToUrl, isMobilePhone } from '../helpers/util';
import { appActions } from '../store/ducks/app';

const mapStateToProps = (state: any) => ({
  user: state.appData.user,
  general: state.appData.general,
  loading: state.appData.loading,
  locationQuery: state.router.location.query,
  prescription: state.appData.prescription,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  loadSubscriptions: () => void;
}
type Props = StateProps & DispatchProps;

class MySubscriptions extends React.Component<Props> {
  componentDidMount() {
    this.props.loadSubscriptions();
  }

  handleBack = (link: any) => {
    if (link !== undefined) {
      redirectToUrl(link);
    }
  };

  render() {
    const showRedirect: boolean = this.props.locationQuery?.redirect;
    const showBackToApp: boolean = !showRedirect && (this.props.locationQuery?.origin === 'mobile' || isMobilePhone());

    if (this.props.loading || !this.props.general || !this.props.prescription) {
      return <Loader />;
    }
    return (
      <ContainerWithFooter>
        <MainTitle>
          <FormattedMessage id="my_subscription" />
        </MainTitle>
        <FlexWrappedRow>
          <FlexCol>
            <AlignedTitle>
              <FormattedMessage id="active_subscription" />
            </AlignedTitle>
            <PlanCTA />
            {
              showRedirect && (
                <ButtonExtraMargin onClick={() => this.handleBack(this.props.locationQuery.redirect)}>
                  <FormattedMessage id="back_to_web" />
                </ButtonExtraMargin>
              )
            }
            {
              showBackToApp && (
                <ButtonExtraMargin onClick={() => this.handleBack(backToAppLink)}>
                  <FormattedMessage id="back_to_app" />
                </ButtonExtraMargin>
              )
            }
            { !showRedirect && !showBackToApp && <Spacer /> }
            <InfoBox />
          </FlexCol>
          <CardInfo />
        </FlexWrappedRow>
        <SubscriptionModals />
      </ContainerWithFooter>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, appActions)(MySubscriptions);
